<template>
  <p class="questionText">{{ question }}</p>
  <div class="form-check form-check-inline">
    <input
      :id="yesQuestionId"
      :name="questionName"
      class="form-check-input"
      type="radio"
      value="true"
      @change="onAnswerChange($event)"
      v-model="yesAnswerSelected"
      :disabled="isDisabled"
    />
    <label class="form-check-label" :for="yesQuestionId">
      Yes
    </label>
  </div>

  <div class="form-check form-check-inline">
    <input
      :id="noQuestionId"
      :name="questionName"
      class="form-check-input"
      type="radio"
      value="false"
      @change="onAnswerChange($event)"
      v-model="noAnswerSelected"
      :disabled="isDisabled"
    />
    <label class="form-check-label" :for="noQuestionId">
      No
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "YesNo",
  emits: ["answerChanged"],
  props: {
    questionKey: { type: String, required: true },
    question: { type: String, required: true },
    answer: { type: Boolean, required: true }
  },
  data() {
    return {
      isDisabled: false
    };
  },
  computed: {
    yesQuestionId: function() {
      return this.questionName + "Yes";
    },
    noQuestionId: function() {
      return this.questionName + "No";
    },
    questionName: function() {
      return "question" + this.questionKey;
    },
    yesAnswerSelected: {
      get: function(): boolean {
        return this.answer;
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      set: function() {}
    },
    noAnswerSelected: {
      get: function(): boolean {
        return this.answer;
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      set: function() {}
    }
  },
  methods: {
    onAnswerChange(a) {
      const answer: boolean = a.target.value as boolean;
      this.$emit("answerChanged", answer);
    },
    setDisabledState(disabledState: boolean) {
      this.isDisabled = disabledState;
    }
  }
});
</script>

<style scoped>
.questionText {
  margin-top: 18px;
  margin-bottom: 8px;
}
</style>
